/**
 * Filtro de calidad GPS: evita publicar caché WiFi (casa) como ubicación en vivo.
 *
 * REACT_APP_GPS_MAX_ACCURACY_M — metros (default 100)
 * REACT_APP_GPS_MAX_FIX_AGE_MS — edad máx. del fix en ms (default 45000)
 */

function envNum(name, fallback) {
  const n = Number(process.env[name]);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

export const GPS_MAX_ACCURACY_M = envNum('REACT_APP_GPS_MAX_ACCURACY_M', 100);
export const GPS_MAX_FIX_AGE_MS = envNum('REACT_APP_GPS_MAX_FIX_AGE_MS', 45_000);

/** GeolocationOptions: nunca devolver caché de "casa por WiFi". */
export const GEO_FRESH = {
  enableHighAccuracy: true,
  timeout: 20000,
  maximumAge: 0,
};

export const GEO_FIRST = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 0,
};

/** Cierre / fallback rápido: sigue sin caché, timeout más corto. */
export const GEO_FAST = {
  enableHighAccuracy: true,
  timeout: 8000,
  maximumAge: 0,
};

export const GEO_WATCH = {
  enableHighAccuracy: true,
  timeout: 20000,
  maximumAge: 0,
};

/**
 * @param {{ lat?: number|null, lng?: number|null, accuracy?: number|null, client_ts?: string|null, timestamp?: number|null }} pos
 * @returns {{ ok: true, pos: object } | { ok: false, reason: string, detail?: string }}
 */
export function assessGpsFix(pos) {
  const lat = Number(pos?.lat);
  const lng = Number(pos?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return { ok: false, reason: 'coords' };
  }
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return { ok: false, reason: 'coords' };
  }

  const accuracyRaw = Number(pos?.accuracy);
  const accuracy =
    Number.isFinite(accuracyRaw) && accuracyRaw >= 0 ? accuracyRaw : null;
  if (accuracy == null) {
    return { ok: false, reason: 'accuracy', detail: 'sin accuracy' };
  }
  if (accuracy > GPS_MAX_ACCURACY_M) {
    return {
      ok: false,
      reason: 'accuracy',
      detail: `${Math.round(accuracy)}m > ${GPS_MAX_ACCURACY_M}m`,
    };
  }

  let fixMs = Date.now();
  if (pos?.client_ts) {
    const parsed = new Date(pos.client_ts).getTime();
    if (Number.isFinite(parsed)) fixMs = parsed;
  } else if (Number.isFinite(Number(pos?.timestamp))) {
    fixMs = Number(pos.timestamp);
  }
  const ageMs = Date.now() - fixMs;
  if (ageMs > GPS_MAX_FIX_AGE_MS) {
    return {
      ok: false,
      reason: 'stale',
      detail: `edad ${Math.round(ageMs / 1000)}s`,
    };
  }
  // Reloj del dispositivo adelantado: rechazar solo si es absurdo
  if (ageMs < -60_000) {
    return { ok: false, reason: 'stale', detail: 'reloj adelantado' };
  }

  return {
    ok: true,
    pos: {
      lat,
      lng,
      accuracy,
      client_ts: new Date(fixMs).toISOString(),
    },
  };
}

export function logSkippedGps(reason, detail) {
  if (typeof console === 'undefined' || !console.info) return;
  console.info(`[GPS] Punto descartado (${reason}${detail ? `: ${detail}` : ''})`);
}
